import { StyledButton, StyledButtonSecondary, StyledLink } from './button-style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Link } from 'react-router-dom';

interface IButtonProps {
  children: any,
  variant?: "primary" | "secondary" | "link",
  id?: string,
  onClick?: () => any,
  disabled?: boolean,
  size?: "medium" | "small",
  icon?: any;
  to?: string; // For link variant
  inverted?: boolean; // For inverted button styles
}

export const Button = ({
  onClick,
  children,
  variant = "primary",
  id = "",
  disabled = false,
  size = "medium",
  icon,
  to,
  inverted
}: IButtonProps) => {
  if (variant === "primary") {
    return (
      <StyledButton onClick={onClick} id={id} disabled={disabled} size={size}>
        {icon && <FontAwesomeIcon icon={icon} color='white' />}
        {children}
      </StyledButton>
    );
  } else if (variant === "secondary") {
    return (
      <StyledButtonSecondary onClick={onClick} id={id} disabled={disabled} size={size} inverted={inverted}>
        {children}
      </StyledButtonSecondary>
    );
  } else if (variant === "link") {
    return (
      <StyledLink>
        <Link to={to || "/"} id={id} style={{ textDecoration: 'none' }}>
          {children}
        </Link>
      </StyledLink>
    );
  }

  return <></>
};